var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.82a6.884 6.884 0 01-10.195 5.971L0 14l1.241-3.659A6.748 6.748 0 01.254 6.82 6.873 6.873 0 0114 6.82zM7.127 1.086A5.762 5.762 0 001.349 6.82a5.673 5.673 0 001.1 3.362l-.722 2.129 2.221-.711a5.784 5.784 0 008.958-4.78 5.763 5.763 0 00-5.779-5.734zM10.6 8.39c-.042-.07-.155-.112-.323-.2s-1-.488-1.151-.544-.267-.084-.379.084-.435.544-.534.655-.2.126-.365.042A4.611 4.611 0 016.491 7.6a5.04 5.04 0 01-.937-1.157c-.1-.167-.01-.258.074-.341s.169-.2.253-.293a1.12 1.12 0 00.168-.279.3.3 0 00-.014-.293c-.042-.084-.379-.906-.52-1.241s-.28-.279-.379-.279-.211-.014-.323-.014a.622.622 0 00-.449.209 1.869 1.869 0 00-.589 1.398 3.234 3.234 0 00.688 1.729 6.887 6.887 0 002.878 2.523c1.713.669 1.713.446 2.022.418a1.7 1.7 0 001.137-.795 1.394 1.394 0 00.1-.795z",
    fill: "#5f48e9"
  })));
}

export default SvgWhatsApp;